/*
* Copyright (c) 2024 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name: AiVision.js
*
* Description: JavaScript code for AiVision module.
*
*/

var g_oAiVision = {};

(function () {
	"use strict";

	/**
	 * Create the AiVision object.
	 */
	function AiVision() {

		// The Checklist Item State enum.
		this.g_ePackCopyProcessStatus = {
			Initial: 0,
			Processing: 1,
			Success: 2,
			Failure: 3
		};

		// If the ai vision menu is in animation.
		this.g_bAiVisionAnimating = false;

		// If the pack copy call is currently processing.
		this.g_bPackCopyProcessing = false;

		// The status poll time in milliseconds.
		this.g_iStatusPollTimeMilliseconds = 1000;

		// The annotation load time in milliseconds.
		this.g_iAnnotationLoadTimeMilliseconds = 3000;
	}

	/**
	 * Processes a pack copy.
	 */
	AiVision.prototype.processPackCopy = function () {

		// Ensure we are not in a compare mode.
		if (g_oViewer.g_oCompareMode != eCompareMode.NoCompare) {
			g_oGreenlightMessages.displayErrorBubble("Please exit compare mode before processing a pack copy.");
			return;
		}

		// Extract the approval id, snapdragon tag set id and ai model to be used.
		var iApprovalId = comboControl_GetApprovalIdByControlId("approvalNameComboControl");
		var iSnapdragonTagSetId = parseInt($("#txtProcessPackCopy_SnapdragonTagSetId").val());
		var szAiModel = $("#txtProcessPackCopy_AiModel").val();

		// Ensure we have a valid approval.
		if (iApprovalId == 0) {
			g_oGreenlightMessages.displayErrorBubble("Please provide a document with an active approval.");
			return;
		}

		// Ensure we have provided a valid snapdragon tag set id.
		if (isNaN(iSnapdragonTagSetId) || iSnapdragonTagSetId <= 0) {
			g_oGreenlightMessages.displayErrorBubble("Please provide a valid Snapdragon Tag Set Id.");
			return;
		}

		// Ensure we have provided a valid ai model.
		if (szAiModel.trim().length == 0) {
			g_oGreenlightMessages.displayErrorBubble("Please provide a valid AI Model.");
			return;
		}

		// Build up the ai vision request to be sent.
		var oJSON = {
			GreenlightApprovalId: iApprovalId,
			SnapdragonTagSetId: iSnapdragonTagSetId,
			AiModel: szAiModel
		};

		// Start the pack copy processing.
		g_oAiVision.startPackCopyProcessing();

		// Call to check for approval annotations.
		$.post({
			url: "GreenlightAiVision/ProcessPackCopyRequest",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {

				// Determine the success of the call.
				if (oResponse.Success && oResponse.Contents.Result && parseInt(oResponse.Contents.PackCopyProcessId) > 0) {
					g_oAiVision.pollPackCopyProcessing(parseInt(oResponse.Contents.PackCopyProcessId));
				}
				else {
					g_oAiVision.endPackCopyProcessing(false, "Failed to process document with AI Vision.");
				}
			},
			failure: function () {
				g_oAiVision.endPackCopyProcessing(false, "Failed to process document with AI Vision.");
			},
			error: function () {
				g_oAiVision.endPackCopyProcessing(false, "Failed to process document with AI Vision.");
			}
		});
	};

	/**
	 * Starts the pack copy processing interface.
	 */
	AiVision.prototype.startPackCopyProcessing = function () {

		// Close the menu.
		g_oAiVision.toggleAiVisionMenu();

		// Set that the pack copy is processing.
		g_oAiVision.g_bPackCopyProcessing = true;

		// Lock the screen.
		g_oProgressBar.addProgressBar("Processing Pack Copy", false);
	};

	/**
	 * Polls the pack copy processing interface.
	 */
	AiVision.prototype.pollPackCopyProcessing = function (iPackCopyProcessId) {

		// Ensure we are still procesing.
		if (!g_oAiVision.g_bPackCopyProcessing) {
			return;
		}

		// Build up the status request to be sent.
		var oJSON = {
			PackCopyProcessId: iPackCopyProcessId
		};

		// Call to check for approval annotations.
		$.post({
			url: "GreenlightAiVision/GetPackCopyProcessStatus",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {

				// Determine the success of the call.
				if (oResponse.Success && parseInt(oResponse.Contents) > 0) {

					// Determine the status of the pack copy process.
					switch (parseInt(oResponse.Contents)) {

						// Processing, poll again.
						case g_oAiVision.g_ePackCopyProcessStatus.Processing:
							setTimeout(function () { g_oAiVision.pollPackCopyProcessing(iPackCopyProcessId); }, g_oAiVision.g_iStatusPollTimeMilliseconds);
							break;

						// Success, end the pack copy processing.
						case g_oAiVision.g_ePackCopyProcessStatus.Success:

							// Load any new annotations made by the pack copy process.
							Approval.DocChangeEvent();

							// Refresh the Snapdragon data.
							g_oAiVision.refreshSnapdragonData();

							// End the pack copy processing.
							setTimeout(function () {
								g_oAnnotations.redrawAnnotations(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
								g_oAiVision.endPackCopyProcessing(true, "Document processed as pack copy.");
							}, g_oAiVision.g_iAnnotationLoadTimeMilliseconds);
							break;

						// Initial or Failure, end the pack copy processing.
						case g_oAiVision.g_ePackCopyProcessStatus.Initial:
						case g_oAiVision.g_ePackCopyProcessStatus.Failure:
							g_oAiVision.endPackCopyProcessing(false, "Failed to process the document as a pack copy.");
							break;
					}
				}
				else {
					g_oAiVision.endPackCopyProcessing(false, "Failed to get the status of the pack copy process.");
				}
			},
			failure: function () {
				g_oAiVision.endPackCopyProcessing(false, "Failed to get the status of the pack copy process.");
			},
			error: function () {
				g_oAiVision.endPackCopyProcessing(false, "Failed to get the status of the pack copy process.");
			}
		});
	};

	/**
	 * Ends the pack copy processing interface.
	 */
	AiVision.prototype.endPackCopyProcessing = function (success, message) {

		// Unlock the screen.
		g_oProgressBar.removeProgressBar();

		// Set that the pack copy is no longer processing.
		g_oAiVision.g_bPackCopyProcessing = false;

		// Display any messages.
		if (success && message.length > 0) {
			g_oGreenlightMessages.displaySuccessBubble(message);
		}
		else if (!success && message.length > 0) {
			g_oGreenlightMessages.displayErrorBubble(message);
		}
	};

	/**
	 * Refreshes the snapdragon data.
	 */
	AiVision.prototype.refreshSnapdragonData = function () {

		// Build up the request to be sent.
		var oJSON = {
			DocumentId: g_oViewer.g_oArtworkViewer.g_oDoc.documentId
		};

		// Call to update the snapdragon data.
		$.post({
			url: "GreenlightAiVision/GetPackCopySnapdragonData",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {
				if (oResponse.Success) {

					// Update the contents of the snapdragon data.
					g_oAnnotationTextClassification.g_oSnapdragonData = oResponse.Contents;

					// Show the text classification annotation type.
					g_oAnnotationTextClassification.showTextClassificationAnnotationType();
				}
				else {
					g_oGreenlightMessages.displayErrorBubble("Failed to refresh the snapdragon data.");
				}
			},
			failure: function () {
				g_oGreenlightMessages.displayErrorBubble("Failed to refresh the snapdragon data.");
			},
			error: function () {
				g_oGreenlightMessages.displayErrorBubble("Failed to refresh the snapdragon data.");
			}
		});
	};

	/**
	 * Downloads the GS1 XML for the pack copy.
	 */
	AiVision.prototype.downloadGS1XML = function () {

		// Extract the approval id.
		var iApprovalId = comboControl_GetApprovalIdByControlId("approvalNameComboControl");

		// Ensure we have a valid approval.
		if (iApprovalId == 0) {
			g_oGreenlightMessages.displayErrorBubble("Failed to get the pack copy GS1 XML. Document has no approval.");
			return;
		}

		// Ensure we have snapdragon data to download.
		if (g_oAnnotationTextClassification.g_oSnapdragonData == null) {
			g_oGreenlightMessages.displayErrorBubble("Failed to get the pack copy GS1 XML. Document has not been processed as a pack copy.");
			return;
		}

		// Build up the ai vision request to be sent.
		var oJSON = {
			ApprovalId: iApprovalId
		};

		// Lock the pack screen.
		g_oAiVision.toggleAiVisionMenu();
		g_oProgressBar.addProgressBar("Downloading Pack Copy XML", false);

		// Call to check for approval annotations.
		$.post({
			url: "GreenlightAiVision/GetPackCopyGS1XML",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {

				// Unlock the screen.
				g_oProgressBar.removeProgressBar();

				// Determine the success of the call, opening the xml when successful.
				if (oResponse.Success && oResponse.Contents.GS1XMLUrl && oResponse.Contents.GS1XMLUrl.length > 0) {
					window.open(oResponse.Contents.GS1XMLUrl, "_blank");
				}
				else {
					g_oGreenlightMessages.displayErrorBubble("Failed to get the pack copy GS1 XML.");
				}
			},
			failure: function () {
				g_oGreenlightMessages.displayErrorBubble("Failed to get the pack copy GS1 XML.");
				g_oProgressBar.removeProgressBar();
			},
			error: function () {
				g_oGreenlightMessages.displayErrorBubble("Failed to get the pack copy GS1 XML.");
				g_oProgressBar.removeProgressBar();
			}
		});
	};

	/**
	 * Toggles the ai vision menu.
	 */
	AiVision.prototype.toggleAiVisionMenu = function () {

		// If we are not already animating the ai vision menu.
		if (!g_oAiVision.g_bAiVisionAnimating) {

			// Set that the menu is currently animating.
			g_oAiVision.g_bAiVisionAnimating = true;

			// If the ai vision menu is currently shown.
			if ($("#divAiVision").css("display") == "none") {

				// Ensure the menu is just off screen.
				$("#divAiVision").css("right", 1 - + $("#divAiVision").width());

				// Show the menu.
				$("#divAiVision").show();

				// Slide the menu in from the right.
				$("#divAiVision").animate({
					right: 7
				}, 'swing', function () {

					// Set that we are no longer animating.
					g_oAiVision.g_bAiVisionAnimating = false;
				});
			}
			// If the ai vision menu is currently not shown.
			else {

				// Slide the menu out to the right.
				$("#divAiVision").animate({
					right: 1 - + $("#divAiVision").width()
				}, 'swing', function () {

					// Hide the menu once the animation has finished.
					$("#divAiVision").hide();

					// Set that we are no longer animating.
					g_oAiVision.g_bAiVisionAnimating = false;
				});
			}
		}
	};

	/*
	 * Ai Vision Menu Auto Closing.
	 */
	$(document).on('click', function (event) {

		// If we are not already animating the ai vision menu, the ai vision menu is curreny open, and we want to close the menu.
		if (!g_oAiVision.g_bAiVisionAnimating && $("#divAiVision").css("display") != "none") {

			// If the click is outside of ai vision menu.
			if ($(event.target).parents("#divAiVision").length == 0 && event.target.id != "divAiVision") {

				// Close the menu.
				g_oAiVision.toggleAiVisionMenu();
			}
		}
	});

	/**
	 * Add the AiVision object to the window.
	 */
	window.AiVision = AiVision;

}());